import { createElement } from "react";

// The application uses a classic hyperscript helper rather than JSX. React's
// modern createElement overloads require `children` inside component props,
// which is incompatible with this call style even though it is valid at runtime.
export const h: (...args: any[]) => React.ReactElement = createElement as any;
